import { useState } from 'react';
import { Stack, TextInput } from '@mantine/core';

import Modal from '@/components/content/modal/Modal';
import Button from '@/components/content/button/Button';

interface CreateKeyModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  isCreating: boolean;
}

const CreateKeyModal = ({ opened, onClose, onConfirm, isCreating }: CreateKeyModalProps) => {
  const [name, setName] = useState('default');

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed) {
      onConfirm(trimmed);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} size="500px" centered title="Create API Key">
      <Stack gap={20}>
        <TextInput
          label="Key Name"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleConfirm();
          }}
          autoFocus
        />
        <Button
          color="var(--quo-green-50)"
          onClick={handleConfirm}
          loading={isCreating}
          disabled={!name.trim()}
        >
          Create
        </Button>
      </Stack>
    </Modal>
  );
};

export default CreateKeyModal;
